module.exports = __webpack_public_path__ + "static/media/52bb1440-75e6-4c5e-8394-bd0dfa0d91b9.4a5fc040.jpeg";